import { LicenseCodeDirective } from './license.directive';
import { PhoneMaskDirective } from './phone-mask.directive';
import { ZipCodeDirective } from './zip-code.directive';

export const directives = [PhoneMaskDirective, ZipCodeDirective, LicenseCodeDirective];
export * from './phone-mask.directive';
export * from './zip-code.directive';

export * from './license.directive';
